export const homeProcessSteps = [
  {
    number: '1',
    title: 'פגישת ייעוץ',
    description: 'פגישת ייעוץ ראשונית להבנת הצרכים שלך',
    freeLabel: true,
  },
  {
    number: '2',
    title: 'אבחון המצב האישי והמשפטי',
    description: 'ניתוח מעמיק של המקרה',
  },
  {
    number: '3',
    title: 'בחירת מסלול',
    description: 'התאמת תכנית פעולה אופטימלית',
  },
  {
    number: '4',
    title: 'תחילת טיפול',
    description: 'יישום התכנית המשפטית',
  },
];

export const insolvencyProcessSteps = [
  ...homeProcessSteps,
  {
    number: '5',
    title: 'ליווי עד לקבלת הפטר',
    description: 'ליווי צמוד עד להסדרת החובות וקבלת הפטר',
  },
];

export const debtResolutionProcessSteps = [
  ...homeProcessSteps,
  {
    number: '5',
    title: 'ליווי עד להסדרת החוב',
    description: 'ליווי צמוד עד להסדרת החוב וסגירת התיק',
  },
];

export const companyLiquidationSteps = [
  {
    number: '1',
    title: 'פגישת ייעוץ',
    description: 'פגישת ייעוץ ראשונית להבנת מצב החברה',
    freeLabel: true,
  },
  {
    number: '2',
    title: 'אבחון המצב המשפטי והעסקי',
    description: 'ניתוח מצב החברה ובחירת מסלול מתאים',
  },
  {
    number: '3',
    title: 'בחירת מסלול',
    description: 'התאמת הליך הפירוק למצב החברה',
  },
  {
    number: '4',
    title: 'תחילת טיפול',
    description: 'הכנת המסמכים והגשתם לרשם החברות',
  },
  {
    number: '5',
    title: 'ליווי עד לסגירת החברה',
    description: 'ליווי עד לסגירת החברה מול רשם החברות',
  },
];

export const monetaryClaimsSteps = [
  {
    number: '1',
    title: 'פגישת ייעוץ',
    description: 'פגישת ייעוץ ראשונית להבנת המקרה והדרישה הכספית',
    freeLabel: true,
  },
  {
    number: '2',
    title: 'אבחון המצב המשפטי והראייתי',
    description: 'ניתוח המסמכים ובחינת סיכויי התביעה',
  },
  {
    number: '3',
    title: 'בחירת מסלול',
    description: 'בחירת דרך פעולה שמתאימה למקרה שלכם',
  },
  {
    number: '4',
    title: 'תחילת טיפול',
    description: 'הכנת מסמכים וניהול ההליך המשפטי',
  },
  {
    number: '5',
    title: 'ליווי עד פסק דין או הסדר',
    description: 'ליווי צמוד עד לפסק דין או הסדר מתאים',
  },
];
